<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

const mexicoDate = new Date().toLocaleDateString('en-CA', {
    timeZone: 'America/Mexico_City'
});

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            send: false,
            form: {
                date: mexicoDate,
                company_id: '',
                user_id: '',
                checkbook_id: '',
                folio: '',
                checks: [],
            },
            authorize: false,
            folioUsed: '',
        }
    },
    methods: {
        async authorizeAndSave() {
            this.form.authorize = true;
            await this.saveBuildings();
        },
        async getFolioCheckbook() {
            if (!this.form.checkbook_id) {
                this.form.folio = '';
                return;
            }
            await this.catalogue.getFoliosCheckbooks(this.form.checkbook_id, this.folioUsed);
        },
        closedModal() {
            this.form.date = mexicoDate;
            this.form.checkbook_id = '';
            this.form.folio = '';
            this.folioUsed = '';
            this.form.company_id = '';
            this.form.user_id = '';
            this.form.checks = [];
            this.form.authorize = false;
            this.$modal.hide('addPayGroupCheckbookFast');
        },
        async saveBuildings() {
            let pass = true;

            if (this.form.authorize) {
                const result = await this.$swal.fire({
                    title: '¿Está seguro de que desea autorizar el cheque?',
                    text: 'Esta acción no puede deshacerse',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sí',
                    cancelButtonText: 'No',
                    reverseButtons: true
                });

                pass = result.isConfirmed;
                if (!pass) {
                    this.form.authorize = false;
                }

                if (!result.isConfirmed) {
                    return false;
                }
            }


            this.send = true;
            const data_form = new FormData();
            data_form.append('date', this.form.date);
            data_form.append('checkbook_id', this.form.checkbook_id);
            data_form.append('folio', this.form.folio);
            data_form.append('type_payment', 6);
            data_form.append('company_id', this.form.company_id);
            data_form.append('user_id', this.form.user_id);
            data_form.append('checks', JSON.stringify(this.form.checks));
            data_form.append('authorize', this.form.authorize);

            let _endpoint = '/checks/update_folio_group';
            if (this.form.authorize) {
                _endpoint = '/checks_pay_group';
            }

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    console.log(data);
                    // this.users = data.data;
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-checks');
                    this.send = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
                this.send = false;
            }

        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-showPayGroupCheckbookFast", async (search, checks) => {
            this.form.company_id = search.company_id;
            this.form.user_id = search.user_id;
            await this.catalogue.get_checkbooks_company(this.form.company_id);
            if (this.catalogue.checkbooks.length == 1) {
                this.form.checkbook_id = this.catalogue.checkbooks[0].id;
                await this.getFolioCheckbook();
            }

            this.form.checks = checks;
            this.$modal.show('addPayGroupCheckbookFast');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    }
}
</script>
<template>
    <modal name="addPayGroupCheckbookFast" :width="'80%'" :maxHeight="380" :adaptive="true" :maxWidth="800"
        :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveBuildings" method="post" enctype="multipart/form-data">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Pago rápido</h5>
            </div>
            <div class="modal-body">
                <div class="row">

                    <div class="col-md-4 mt-2">
                        <label>Fecha de pago</label>
                        <date-picker v-model="form.date" :disabled="!prop_edit" valueType="format">
                        </date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Chequera</label>
                        <select type="text" class="form-control" v-model="form.checkbook_id" :disabled="!prop_edit"
                            @change="getFolioCheckbook()">
                            <option value=""> Sin chequera</option>
                            <option v-for="(check, index) in catalogue.checkbooks" :value="check.id" :key="index">
                                <span v-if="check.bank">
                                    {{ check.bank.name }} -
                                </span>
                                {{ check.name }} {{ check.id_ini }} / {{ check.id_end }}
                            </option>
                        </select>
                        <div v-if="errors && errors.checkbook_id" class="text-danger">{{ errors.checkbook_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Folio</label>
                        <select type="text" class="form-control" v-model="form.folio" :disabled="!prop_edit">
                            <option value=""> Sin folio</option>
                            <option v-for="(folio, index) in catalogue.folios_checkbooks" :value="folio" :key="index">
                                {{ folio }}
                            </option>

                        </select>
                        <div v-if="errors && errors.folio" class="text-danger">{{ errors.folio[0] }}</div>
                    </div>
                    <div class="col-md-12 mt-2">
                        <hr>
                    </div>
                    <div class="col-md-12" v-for="(check, index) in form.checks" :key="index">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <strong>Monto:</strong>
                                        {{ check.amount_payable | toCurrency }}
                                    </div>
                                    <div class="col-md-6">
                                        <strong>Descripción:</strong>
                                        {{ check.description }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="col-md-12">
                        <hr>

                        <button type="submit" v-if="prop_edit && !form.authorize" :disabled="send"
                            class="btn float-right btn-outline-success mr-2">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>

                        <!-- Botón de autorizar -->
                        <button type="button" v-if="prop_edit && !send" class="btn float-right btn-outline-success"
                            @click="authorizeAndSave()">
                            <i class="fas fa-check"></i> Autorizar
                        </button>
                        
                        <!-- <button type="submit" v-if="prop_edit" :disabled="send"
                            class="btn float-right btn-outline-success" @click="form.authorize = !form.authorize">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Autorizando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Autorizar
                            </span>
                        </button>

                        <button type="submit" v-if="prop_edit" :disabled="send"
                            class="btn float-right btn-outline-success mr-2">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button> -->

                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>